<template>
  <div>
    <v-row v-if="displayMode === 0" class="text-left search-bar search-bar-max ma-0" style="flex-shrink: 0;">
      <v-col cols="8" class="pl-8 pa-0" style="display: flex; align-items: center;">
        <v-row class="my-0 align-center" style="align-content: center">
          <v-col class="pa-0 col-5 d-flex align-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="#ED6D00" size="18" class="mr-2" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span style="white-space: pre-line; text-align: left; display: block;">{{ $t('__keywordSearchTooltip') }}</span>
            </v-tooltip>
            <v-text-field outlined :placeholder="$t('__keywordSearch')" class="mt-2 keyword text_field"
            dense v-model="keyword" background-color="white" @keyup.enter="search">
              <template v-slot:append>
                <v-icon class="my-1" color="white" style="background:#ED6D00" @click="search">
                icon-form_search
                </v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-btn class="ma-1 pa-0 py-1" outlined style="border:none; height:34px; min-width:50px;  border-radius: 8px; background:#777" @click="close()">
            <v-icon color="white" size="20">mdi-close</v-icon>
          </v-btn>
        </v-row>
      </v-col>
      <v-col cols="4" class="pr-8 pa-0 d-flex justify-end align-center">
      </v-col>
    </v-row>

    <v-row v-if="displayMode === 1" class="text-left search-bar ma-0 pa-0 search-bar-min">
      <v-expansion-panels accordion style="z-index: 3">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-icon class="ml-0 mr-3">
              icon-form_search
            </v-icon>
            {{$t('__categorySearch')}}
            <template v-slot:actions>
              <v-icon>
                $expand
              </v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div>
              <v-row justify="center">
                <v-col class="pa-0 col-7 d-flex align-center">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="#ED6D00" size="18" class="mr-2" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                    </template>
                    <span style="white-space: pre-line; text-align: left; display: block;">{{ $t('__keywordSearchTooltip') }}</span>
                  </v-tooltip>
                  <v-text-field outlined :placeholder="$t('__keywordSearch')" class="keyword text_field"
                  dense v-model="keyword" background-color="white" style="margin-top: 4px; flex-grow: 1;">
                    <template v-slot:append>
                      <v-icon class="my-1" color="white" style="background:#ED6D00" @click="search">
                      icon-form_search
                      </v-icon>
                    </template>
                  </v-text-field>
                </v-col>
                <v-btn class="ma-1 pa-0 py-1" outlined style="border:none; height:34px; min-width:50px;  border-radius: 8px; background:#777" @click="close()">
                  <v-icon color="white" size="20">mdi-close</v-icon>
                </v-btn>
              </v-row>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>

    <v-row id="router" class="ma-0 pa-0" :style="viewStyle">
      <div id="listTable">
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
              <tr class="text-center">
                <th class="text-center">{{$t('__View')}}</th>
                <th @click="sort('no')">{{$t('__no')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('caseId')">{{$t('__caseId')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('customer')">{{$t('__customer')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('item')">{{$t('__item')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('reporter')">{{$t('__reporter')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('createTime')">{{$t('__createTime')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('closeTime')">{{$t('__closeTime')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('durationDays')">{{$t('__duration')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('assigned')">{{$t('__assigned')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('status')">{{$t('__jobStatus')}}<v-icon small>icon-form_sort_off</v-icon></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data,index) in datasets" :key="index" id="table_body">
                <td class="text-center" style="min-width:110px">
                  <v-avatar color="#979491" size="30" tile @click="$refs.PdfDownload.open(data.encryptedId || data.id,'history', data.caseId)"
                    class="mr-1 action-btn-pdf" style="cursor: pointer;">
                    <div style="width: 24px; padding-top:2px">
                      <v-img :src="images.PDF" alt="PDF icon"></v-img>
                    </div>
                  </v-avatar>
                  <v-avatar color="#ED6D00" size="30" tile @click="redirectPath('/jobAssignment', data.encryptedId || data.id)"
                    class="action-btn-edit" style="cursor: pointer;">
                    <v-icon color="#FFFFFF" size="20">mdi-eye-outline</v-icon>
                  </v-avatar>
                </td>
                <td style="min-width:95px"><h4 class="content">{{data.id}}</h4></td>
                <td style="min-width:120px"><h4 class="content">{{data.caseId}}</h4></td>
                <td style="min-width:120px"><h4 class="content">{{data.customer}}</h4></td>
                <td style="min-width:145px"><h4 class="content">{{data.item}}</h4></td>
                <td style="min-width:110px"><h4 class="content">{{data.reporter}}</h4></td>
                <td style="min-width:140px"><h4 class="content">{{data.createTimeString}}</h4></td>
                <td style="min-width:140px"><h4 class="content">{{data.closeDateString}}</h4></td>
                <td style="min-width:110px"><h4 class="content">{{data.durationDays}}</h4></td>
                <td style="min-width:120px"><h4 class="content">{{data.assigned}}</h4></td>
                <td style="min-width:110px"><h4 class="content">{{data.status}}</h4></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    
      <v-row class="ma-0 px-4 justify-center justify-lg-end">
        <v-col cols="12" lg="6" class="pa-0"></v-col>
        <v-col cols="12" lg="6">
          <v-row class="ma-0 align-center" style="justify-content: center">
            <v-col cols="12" lg="auto" class="d-none d-lg-flex align-center">
              {{ $tc('__totalCount', pagination.totalCount, { count: pagination.totalCount }) }}
            </v-col>
            <v-col cols="12" lg="auto" class="d-flex justify-center">
              <v-pagination color="#ED6D00" :total-visible="5" :length="pagination.totalPage" v-model="pagination.page"/>
            </v-col>
            <v-col cols="12" lg="auto" class="d-flex justify-center justify-lg-end align-center">
              <span class="mr-2">{{ $t('__go') }}</span>
              <v-text-field class="mx-1 text-center" min="1" :max="pagination.totalPage" type="number"
              dense outlined hide-details style="max-width: 80px" @keyup.enter="setDestPage()" v-model="destPage"/>
              <span class="ml-1">{{ $t('__page') }}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-row>

    <PdfDownload ref="PdfDownload"/>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n'
import PdfDownload from '@/dialogs/PdfDownload'

export default {
  name: 'HistoryRecordList',
  components: {PdfDownload},
  mounted(){
    this.language = i18n.locale
    this.getDataset()
    this.destPage = this.pagination.page
  },
  data:() => ({
    select:'',
    keyword:'',
    language:'',
    datasets: [],
    pagination:{page:1,totalPage:1,totalCount:0},
    pageSize: 10,
    orderBy:'id',
    direction:'desc',
    destPage:'',
    viewStyle:{},
    displayMode:'',

    images:{
      PDF: require('@/assets/image/PDF.png'),
    },
  }),
  created(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
    this.$root.$on('language',(value)=>{
      this.language = value
    })
  },
  watch:{
    "pagination.page":function(val){
      this.destPage = val
      this.getDataset()
    },
    "keyword":function(){
      this.getDataset()
    },
  },
  computed: {},
  methods:{
    close(){
      this.keyword = ''
    },
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-128 + 'px'}
      if(window.innerWidth >= 960){
        this.displayMode = 0
      } else {
        this.displayMode = 1
      }
    },
    redirectPath(path, id){
      let tmp = {
        keyword: this.keyword,
      }
      sessionStorage.setItem('search',JSON.stringify(tmp))
      sessionStorage.setItem('isClosedJob', 'true')
      this.$router.push({path: path, query: {id: id,page: this.pagination.page}})
    },
    setDestPage(){
      let page = parseInt(this.destPage)
      if (isNaN(page) || page < 1) {
        page = 1
      }
      if (page > this.pagination.totalPage) {
        page = this.pagination.totalPage
      }
      this.destPage = page
      if (this.pagination.page === page) {
        this.getDataset()
      } else {
        this.pagination.page = page
      }
    },
    sort(field){
      this.orderBy = field
      this.direction = (this.direction == 'desc') ? 'asc' : 'desc'
      this.getDataset()
    },
    search(){
      (this.pagination.page == 1) ? this.getDataset() : this.pagination.page = 1
    },
    getDataset(){
      var self = this
      var request = {
        method: 'GET',
        url: '/GetClosedJobAssignmentList',
        params: {
          'orderBy': self.orderBy,
          'direction': self.direction,
          'pageSize': 10,
          'currentPage': self.pagination.page,
          'limit': self.pageSize,
          'keyword':self.keyword != ''? self.keyword: null,
        },
      }
      this.$http(request).then(function(response) {
        self.datasets = response.data.Data
        self.pagination.totalPage = response.data.TotalPageCount
        self.pagination.totalCount = response.data.TotalCount
      }).catch(()=>{
        alert(this.$t('__systemError', { code: 'His-7971' }))
      }).finally(()=>{
      })
    },
    
  }
}
</script>

<style>
  @media (min-width: 960px) {
    .search-bar-min {
      display: none !important;
    }
  }
  @media (max-width: 959px) {
    .search-bar-max, .pagination-max {
      display: none !important;
    }
  }

  /* Action buttons hover effects */
  .action-btn-pdf:hover {
    opacity: 0.8;
    transition: opacity 0.2s;
  }

  .action-btn-edit:hover {
    opacity: 0.8;
    transition: opacity 0.2s;
  }

  .centered-input >>> input {
    text-align: center;
  }
  .centered-input >>> input[type=number] {
    -moz-appearance: textfield;
  }
</style>